import axiosCommon from '../helper/axiosCommon'
import qs from 'qs'


async function updateOne(map) {
  const req = axiosCommon.getAxiosParamsAuth(`/maps/${map.id}`, 'put', map)
  return await axiosCommon.axiosRequest(req)
}

async function deleteOne(id) {
  const req = axiosCommon.getAxiosParamsAuth(`/maps/${id}`, 'delete')
  return await axiosCommon.axiosRequest(req)
}

async function createOne(map) {
  const req = axiosCommon.getAxiosParamsAuth('/maps', 'post', map)
  return await axiosCommon.axiosRequest(req)
}

async function readPaginated(query) {
  const req = axiosCommon.getAxiosParamsAuth('/maps?' + qs.stringify(query), 'get')
  return await axiosCommon.axiosRequest(req)
}


export default {
  updateOne,
  deleteOne,
  createOne,
  readPaginated,
}


